import styles from "./styles.module.scss";
import { LogoWithText } from 'assets/vectors';
import { Support } from 'layout/support';
import { useParams } from 'react-router-dom';
import { CandidateChatMessages, Spinner } from 'components';
import { useGetAssessmentInfo, useToast } from "hooks";
import { useEffect } from "react";

const PreAssessmentUI = () => {
  const { id } = useParams();
  const { openToast } = useToast();
  const { fetchAssessmentInfo, assessmentInfo, isLoading: isLoadingGetAssessmentInfo, error: assessmentInfoError } = useGetAssessmentInfo(id ?? '');
  useEffect(() => {
    if (id) {
      fetchAssessmentInfo();
    }
  }, [id]);
  useEffect(() => {
    if (assessmentInfoError) {
      openToast({ show: true, heading: 'Error', text: 'Error Fetching Company Info', type: 'error', timeOut: 5000 });
    }
  }, [id]);

  const assessment = {
    employer: {
      name: "Precision",
    },
    title: "Software Engineer",
  };

  return (
    <div className={styles.container}>
      <nav className={styles.nav}>
        {assessmentInfo?.data?.company_info?.company_logo && <img
          className={styles.logo}
          src={assessmentInfo?.data?.company_info?.company_logo}
          alt="employer logo"
        />}
        {isLoadingGetAssessmentInfo ? <Spinner className={styles.spinner} /> : <h3 className={styles.title}>
          {assessmentInfo?.data?.company_info?.name}
        </h3>}
        {assessmentInfoError && <h3 className={styles.title}>
          --/--
        </h3>}
      </nav>
      <div className={styles.content}>
        <div className={styles.assessmentChat}>
          <CandidateChatMessages assessmentId={String(id)} />
        </div>
      </div>
      <footer className={styles.footer}>
        <footer className={`${styles.footerLogo} ${styles.container}`}>
          <span>Enabled by</span> <LogoWithText />{" "}
        </footer>
        <Support
          text="Need help?"
          message={`Hello, I am a candidate from ${assessment.employer.name} and I am taking an assessment for the ${assessment.title} role. I need help with a problem I'm having.`}
        />
      </footer>
    </div>
  )
}

export { PreAssessmentUI };